import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@/core/components/line-clamped-tooltip";
import { IPayout } from "@/payouts/payouts";

export const NoteCol = (): ColumnDef<IPayout> => ({
  header: "Note",
  accessorKey: "notes",
  cell: ({ row }) => (
    <LineClampedTooltip>{row.original.notes}</LineClampedTooltip>
  ),
});
